import { render } from "./modal-detail-product.vue?vue&type=template&id=3114d644&ts=true"
import script from "./modal-detail-product.vue?vue&type=script&lang=ts"
export * from "./modal-detail-product.vue?vue&type=script&lang=ts"

import "./modal-detail-product.vue?vue&type=style&index=0&id=3114d644&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__